{
	"title": "Veelgestelde vragen",
	"description": "De vragen en antwoorden in de shop, in de volgorde die je kiest.",
	"empty": "Er zijn nog geen vragen.",
	"orderHint": "Sleep een vraag naar een andere plek, of gebruik de pijltjes. De shop toont ze in deze volgorde.",
	"list": "Vragen",
	"drag": "Verslepen: {{question}}",
	"moveUp": "Omhoog: {{question}}",
	"moveDown": "Omlaag: {{question}}",
	"moved": "{{question}} staat nu op plek {{position}} van {{total}}.",
	"reorderFailed": "De nieuwe volgorde is niet opgeslagen. Probeer het opnieuw.",
	"reorderOutdated": "De lijst is intussen veranderd. Hij is opnieuw geladen; zet de vraag nog eens op zijn plek.",
	"new": {
		"title": "Vraag toevoegen",
		"description": "Een nieuwe vraag komt onderaan de lijst.",
		"submit": "Toevoegen"
	},
	"edit": {
		"title": "Vraag bewerken",
		"submit": "Opslaan"
	},
	"field": {
		"question": "Vraag",
		"answer": "Antwoord",
		"answerDescription": "In markdown: **vet**, *schuin*, - opsomming, [link](https://…).",
		"preview": "Voorbeeld",
		"previewEmpty": "Typ een antwoord om het voorbeeld te zien.",
		"published": "Gepubliceerd",
		"publishedDescription": "Aan: de vraag staat in de shop. Uit: alleen jij ziet hem hier.",
		"topic": "Onderwerp",
		"chooseTopic": "Kies een onderwerp",
		"topicDescription": "De pagina met veelgestelde vragen groepeert de vragen op onderwerp.",
		"category": "Categorie",
		"noCategory": "Geen categorie",
		"categoryDescription": "Staat de vraag ook onderaan de pagina van een categorie, zoals een wisserpagina? Kies die hier."
	},
	"changed": "Iemand anders heeft deze vraag intussen opgeslagen. Laad de vraag opnieuw; je wijzigingen gaan dan verloren.",
	"reload": "Opnieuw laden",
	"delete": {
		"button": "Verwijderen",
		"title": "Vraag verwijderen?",
		"description": "\"{{question}}\" verdwijnt uit het beheer en uit de shop. Dit kun je niet ongedaan maken.",
		"confirm": "Verwijderen"
	},
	"topic": {
		"fit": "Pasvorm",
		"ordering": "Bestellen",
		"payment": "Betalen",
		"shipping": "Verzenden",
		"business": "Zakelijk"
	},
	"topicOnCategory": "{{topic}} · op {{category}}",
	"categoryNotFound": "Deze categorie bestaat niet meer. Kies een andere.",
	"help": {
		"faq": {
			"title": "Veelgestelde vragen",
			"area": "Content › Veelgestelde vragen",
			"short": "De vragen op cleanbudget.nl/veelgestelde-vragen, per onderwerp, in de volgorde van deze lijst. Sleep een vraag of gebruik de pijltjes: de nieuwe volgorde staat meteen in de shop.",
			"warning": "Dezelfde volgorde geldt op een wisserpagina, met de eerste drie vragen van die categorie, en op de pagina Welke past op mijn wisser, met alle vragen over Pasvorm.",
			"terms": ["faqItem:item", "faqItem:topic", "faqItem:category", "category:holderPage"]
		},
		"item": {
			"title": "Vraag",
			"area": "Content › Veelgestelde vragen",
			"short": "Een vraag met een antwoord dat openklapt. Het onderwerp bepaalt onder welk kopje hij staat, de categorie of hij ook op een wisserpagina staat. Een klant ziet hem pas als hij gepubliceerd is.",
			"terms": ["faqItem:answer", "faqItem:topic", "faqItem:category", "faqItem:published"]
		},
		"answer": {
			"title": "Antwoord",
			"area": "Content › Veelgestelde vragen › Vraag",
			"short": "Het antwoord klapt open onder de vraag. Je schrijft het in markdown, zoals een pagina: vet, een lijst of een link naar een pagina van de shop. Houd het bij een paar zinnen.",
			"terms": ["page:markdown"]
		},
		"topic": {
			"title": "Onderwerp",
			"area": "Content › Veelgestelde vragen › Vraag",
			"short": "De pagina Veelgestelde vragen zet de vragen per onderwerp onder een kopje, met bovenaan een knop per onderwerp. Een onderwerp zonder gepubliceerde vraag laat de shop weg.",
			"choices": [
				{
					"name": "Pasvorm",
					"text": "Welke navulling past op welke houder. Deze vragen staan ook op de pagina Welke past op mijn wisser."
				},
				{
					"name": "Bestellen",
					"text": "Over de mand, de bestelling en het account."
				},
				{
					"name": "Betalen",
					"text": "Over betaalmethodes, op rekening en facturen."
				},
				{
					"name": "Verzenden",
					"text": "Over levertijd, verzendkosten en retourneren."
				},
				{
					"name": "Zakelijk",
					"text": "Over een zakelijk account, klantprijzen en btw."
				}
			]
		},
		"category": {
			"title": "Categorie bij een vraag",
			"area": "Content › Veelgestelde vragen › Vraag",
			"short": "Kies je een categorie met een houder, dan staat de vraag ook onderaan die wisserpagina. Daar staan de eerste drie, in de volgorde van de lijst, met een link naar alle vragen.",
			"terms": ["category:holderPage"]
		},
		"published": {
			"title": "Gepubliceerd",
			"area": "Content › Veelgestelde vragen › Vraag",
			"short": "Aan: de vraag staat in de shop, onder zijn onderwerp. Uit: je ziet hem alleen in het beheer; hij houdt zijn plek in de lijst.",
			"warning": "Zet je een vraag uit, dan verdwijnt hij overal: van de pagina Veelgestelde vragen, van de wisserpagina en uit Welke past op mijn wisser."
		}
	},
	"helpExample": {
		"faq": {
			"label": "De veelgestelde vragen in de shop: onder het kopje Verzenden twee vragen, de eerste open met zijn antwoord.",
			"topic": "Verzenden",
			"items": {
				"first": {
					"question": "Wanneer is mijn bestelling er?",
					"answer": "Op werkdagen vóór 16:00 besteld, dan is hij **de volgende werkdag** in huis."
				},
				"second": {
					"question": "Kan ik iets terugsturen?",
					"answer": "Ja, binnen 30 dagen. Lees hoe op [Verzenden en retourneren](/verzenden-en-retourneren)."
				}
			}
		}
	}
}
